/**
 * 權限初始化插件
 * 在應用啟動時檢查登入狀態，只有已登入的用戶才載入權限規則和 API 群組資料
 * 避免在各個組件中重複載入
 */
export default defineNuxtPlugin({
  name: 'permissions-client',
  dependsOn: ['pinia'],
  async setup() {
    // 檔名的 .client 後綴已經保證只在瀏覽器端執行，這裡不需要再判斷一次
    try {
      // 延遲執行以確保 pinia 和其他依賴已經初始化
      await nextTick();

      const authStore = useAuthStore();
      const roleStore = useRoleStore();

      // 檢查用戶是否已登入
      if (!authStore.isLoggedIn()) {
        // console.log('user not logged in, skip permission data loading')
        return;
      }

      // 並行載入權限資料
      await Promise.all([
        roleStore.getMemberRules(),
        // roleStore.getApiGroups()
        roleStore.getAllUserAuthApis(),
      ]);
    } catch (error) {
      console.warn('load permission data failed:', error);
      // 不阻擋應用啟動，讓組件可以fallback到原本的載入邏輯
    }
  },
});
